import React, { useState, useEffect } from "react";
import {
  Accordion,
  Button,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
} from "react-bootstrap";
import { IoLogoWhatsapp } from "react-icons/io";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import AddTagModal from "../../components/Modals/AddTagModel";
import { MdCancel, MdCheckCircle } from "react-icons/md";

import ExportModal from "../../components/Modals/ExportsModel/main";
import ImportModal from "../../components/Modals/ImportModel";
import { useCommonContext } from "../../utils/context";
import { useTypeConfig } from "../../utils/useTypeConfig";

function SubCustomerList() {
  const { user } = useCommonContext();
  const { labels, hiddenFields } = useTypeConfig();
  // const [subCustomers, setSubCustomers] = useState([]);
  const [showAddTagModal, setShowAddTagModal] = useState(false);
  const [editSubCustomerData, setEditSubCustomerData] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [subCustomers, setSubCustomers] = useState([]);
  const [statusFilter, setStatusFilter] = useState("active");
  const role = localStorage.getItem("role");

  const fetchSubCustomers = async () => {
    if (!user?.id) return;
    try {
      let url = `${BASE_URL}/users/tms_users/?role=subcustomer&customer_id=${user?.id}&page_size=all`;

      if (searchText) {
        url += `&search=${encodeURIComponent(searchText)}`;
      }
      if (statusFilter) {
        url += `&is_active=${statusFilter}`;
      }

      const { data } = await axios.get(url, { headers: HEADERS });
      setSubCustomers(data?.results || []);
    } catch (error) {
      // toast.error("Failed to fetch sub-customers. Please try again.");
      // console.error("Error fetching sub-customers:", error);
    }
  };

  useEffect(() => {
    if (user?.id) {
      fetchSubCustomers();
    }
  }, [user?.id, searchText, statusFilter]);

  const handleSearchTextChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleEditSubCustomer = (subCustomer) => {
    setEditSubCustomerData(subCustomer);
    setShowAddTagModal(true);
  };

  const handleAddSubCustomer = () => {
    setEditSubCustomerData(null);
    setShowAddTagModal(true);
  };

  const handleCloseModals = () => {
    setEditSubCustomerData(null);
    setShowAddTagModal(false);
    setShowImportModal(false);
  };

  const handleToggleSubActive = async (subCustomerId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${subCustomerId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        toast.success(
          `Sub Customer ${
            currentStatus ? "deactivated" : "activated"
          } successfully!`,
        );

        setSubCustomers((prevSubCustomers) =>
          prevSubCustomers.map((subCustomer) =>
            subCustomer.id === subCustomerId
              ? { ...subCustomer, is_active: !currentStatus }
              : subCustomer,
          ),
        );
      } else {
        toast.error("Failed to update Sub customer status. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Please Try again.");
      }
    }
  };

  const handleDeleteSubCustomer = async (subCustomerId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/users/tms_users/${subCustomerId}/`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        toast.success("Sub Customer deleted successfully!");
        setSubCustomers((prev) =>
          prev.filter((sub) => sub.id !== subCustomerId),
        );
      } else {
        toast.error("Failed to delete Sub customer. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
      }
    }
  };

  const isAddressEmpty = (address) => {
    return (
      !address?.primary_address &&
      !address?.city &&
      !address?.landmark_paci &&
      !address?.state &&
      !address?.zipcode &&
      !address?.country
    );
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">Subcustomers</h4>

        <div className="d-none d-md-flex align-items-center">
          <div className="me-2">
            <input
              type="text"
              className="form-control common-input"
              value={searchText}
              placeholder="Search Here..."
              onChange={(e) => setSearchText(e.target.value)}
              style={{ minWidth: "200px" }}
            />
          </div>
          <div className="me-2 ">
            <Form.Control
              as="select"
              value={
                statusFilter === true
                  ? "is_active"
                  : statusFilter === false
                    ? "!is_active"
                    : ""
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "is_active") {
                  setStatusFilter(true);
                } else if (value === "!is_active") {
                  setStatusFilter(false);
                } else {
                  setStatusFilter(null);
                }
              }}
              className="w-md-auto common-input"
            >
              <option value="">All</option>
              <option value="is_active">Active</option>
              <option value="!is_active">Inactive</option>
            </Form.Control>
          </div>
          <div className="d-flex flex-wrap ">
            {role !== "customer" && (
              <>
                <Button
                  variant="primary"
                  onClick={handleAddSubCustomer}
                  className="me-2"
                >
                  Add
                </Button>

                <Button
                  variant="primary"
                  onClick={() => setShowImportModal(true)}
                  className="me-2"
                >
                  Import
                </Button>
              </>
            )}

            <Button
              variant="primary"
              onClick={() => setShowExportModal(true)}
              className="me-2 "
              disabled={exportLoading}
            >
              {exportLoading ? "Exporting..." : "Export"}
            </Button>
          </div>
        </div>

        <div className="d-md-none">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body>
                <div className="me-2">
                  <input
                    type="text"
                    className="form-control common-input"
                    value={searchText}
                    placeholder="Search Here..."
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ minWidth: "200px" }}
                  />
                </div>
                <div className="me-2 ">
                  <Form.Control
                    as="select"
                    value={
                      statusFilter === true
                        ? "is_active"
                        : statusFilter === false
                          ? "!is_active"
                          : ""
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "is_active") {
                        setStatusFilter(true);
                      } else if (value === "!is_active") {
                        setStatusFilter(false);
                      } else {
                        setStatusFilter(null);
                      }
                    }}
                    className="w-md-auto common-input"
                  >
                    <option value="">All</option>
                    <option value="is_active">Active</option>
                    <option value="!is_active">Inactive</option>
                  </Form.Control>
                </div>
                <div className="d-flex flex-wrap ">
                  {role !== "customer" && (
                    <>
                      <Button
                        variant="primary"
                        onClick={handleAddSubCustomer}
                        className="me-2"
                      >
                        Add
                      </Button>

                      <Button
                        variant="primary"
                        onClick={() => setShowImportModal(true)}
                        className="me-2 "
                      >
                        Import
                      </Button>
                    </>
                  )}
                  <Button
                    variant="primary"
                    onClick={() => setShowExportModal(true)}
                    className="me-2 "
                    disabled={exportLoading}
                  >
                    {exportLoading ? "Exporting..." : "Export"}
                  </Button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${subCustomers.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "500px" }}
          >
            <Loader />
          </div>
        ) : (
          <>
            {subCustomers.length > 0 ? (
              <table className="table table-bordered  tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ width: "350px" }}>Subcustomer Name</th>
                    <th style={{ width: "300px" }}>Company Name</th>
                    <th style={{ width: "300px" }}>Email</th>
                    <th style={{ width: "200px" }}>Mobile No.</th>
                    <th style={{ width: "400px" }}>Address</th>
                    <th style={{ width: "200px" }}>Region</th>
                    <th style={{ width: "150px" }}>Since</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "150px" }}></th>
                    {/* <th style={{ width: "150px" }}></th> */}
                  </tr>
                </thead>
                <tbody>
                  {subCustomers.map((subCustomer) => (
                    <tr key={subCustomer.id} className="tbody">
                      <td>
                        <div className="d-flex align-items-center ">
                          <span className="badge bg-primary text-white me-2">
                            {subCustomer.id}
                          </span>
                          <img
                            src={
                              subCustomer.profile_image ||
                              "https://via.placeholder.com/40"
                            }
                            alt="Profile"
                            className="rounded-circle border me-2"
                            style={{ width: "30px", height: "30px" }}
                          />
                          <div
                            title={subCustomer.customer_name || "—"}
                            className="tdsubject"
                          >
                            {subCustomer.customer_name || "—"}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          title={subCustomer.company_name || "—"}
                          className="tdsubject"
                        >
                          {subCustomer.company_name || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={subCustomer.email || "—"}
                          className="tdsubject"
                        >
                          {subCustomer.email || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={subCustomer.phone_number || "—"}
                          className="tdsubject"
                        >
                          {subCustomer.phone_number || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            isAddressEmpty(subCustomer)
                              ? "—"
                              : `${subCustomer?.primary_address || ""} ${
                                  subCustomer?.city || ""
                                } ${subCustomer?.landmark_paci || ""} ${
                                  subCustomer?.state || ""
                                } ${subCustomer?.zipcode || ""} ${
                                  subCustomer?.country || ""
                                }`.trim()
                          }
                          className="tdsubject"
                        >
                          {isAddressEmpty(subCustomer) ? (
                            "—"
                          ) : (
                            <div className="tdsubject">
                              {subCustomer?.primary_address && (
                                <strong>{subCustomer?.primary_address}</strong>
                              )}
                              {(subCustomer?.city ||
                                subCustomer?.landmark_paci ||
                                subCustomer?.state) && (
                                <>
                                  <br />
                                  {subCustomer?.city && (
                                    <>{subCustomer?.city}</>
                                  )}
                                  {subCustomer?.landmark_paci && (
                                    <>
                                      {subCustomer?.city ? ", " : ""}
                                      {subCustomer?.landmark_paci}
                                    </>
                                  )}
                                  {subCustomer?.state && (
                                    <>
                                      {subCustomer?.city ||
                                      subCustomer?.landmark_paci
                                        ? ", "
                                        : ""}
                                      {subCustomer?.state}
                                    </>
                                  )}
                                </>
                              )}
                              {(subCustomer?.zipcode ||
                                subCustomer?.country) && (
                                <>
                                  {subCustomer?.zipcode && (
                                    <>{subCustomer?.zipcode}</>
                                  )}
                                  {subCustomer?.country && (
                                    <>
                                      {subCustomer?.zipcode ? ", " : ""}
                                      {subCustomer?.country}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <div
                          title={subCustomer.region || "—"}
                          className="tdsubject"
                        >
                          {subCustomer.region || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={subCustomer.created_at || "—"}
                          className="tdsubject"
                        >
                          {subCustomer.created_at || "—"}
                        </div>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            subCustomer.is_active ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {subCustomer.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>

                      <td>
                        <a
                          href={`https://api.whatsapp.com/send/?phone=${encodeURIComponent(
                            `+91${subCustomer.phone_number}`,
                          )}&text=Hello`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-success"
                        >
                          <IoLogoWhatsapp size={16} />
                        </a>
                      </td>

                      {/* <td>
                        <DropdownButton
                          id="dropdown-basic-button"
                          title={<BsThreeDotsVertical />}
                          variant="link"
                          className="p-0 text-secondary custom-dropdown"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Dropdown.Item
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditSubCustomer(subCustomer);
                            }}
                          >
                            <FaEdit className="me-1" /> Edit
                          </Dropdown.Item>
                          {role === "admin" && (
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteSubCustomer(subCustomer.id);
                              }}
                            >
                              <FaTrashAlt className="me-1" /> Delete
                            </Dropdown.Item>
                          )}
                          <Dropdown.Item
                            as="button"
                            onClick={(e) => {
                              e.stopPropagation(); // Stop the row click event
                              handleToggleSubActive(
                                subCustomer.id,
                                subCustomer.is_active,
                              );
                            }}
                          >
                            {subCustomer.is_active ? (
                              <>
                                <MdCancel className="me-1" /> Deactivate
                              </>
                            ) : (
                              <>
                                <MdCheckCircle className="me-1" /> Activate
                              </>
                            )}
                          </Dropdown.Item>
                        </DropdownButton>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>
      <AddTagModal
        show={showAddTagModal}
        handleClose={handleCloseModals}
        subCustomerData={editSubCustomerData}
        fetchSubCustomers={fetchSubCustomers}
        selectedCustomer={user}
      />

      <ImportModal
        show={showImportModal}
        handleClose={handleCloseModals}
        type="subcustomers"
        onSuccess={fetchSubCustomers}
      />
      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="subcustomers"
      />
    </div>
  );
}

export default SubCustomerList;
